
export function maskedNumberInputShiftWorkaround(el: any, regExp: RegExp) {
  let match: string[];
  if (regExp && el && typeof el.value === 'string' && (match = el.value.match(regExp))) {
    const len1 = el.value.length;
    const nLen1 = (match || ['']).join('').length;
    if (el.selectionEnd === len1) {
      setTimeout(() => {
        const len2 = el.value.length;
        const nLen2 = el.value.match(regExp).join('').length;
        if (len1 !== len2 && el.selectionEnd !== len2 && el.setSelectionRange && nLen1 === nLen2) {
          el.setSelectionRange(len2, len2);
        }
      }, 10);
    }
  }
}
